import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

export const flowable: AppRouteModule = {
  path: '/flowable',
  name: 'flowable',
  component: LAYOUT,
  redirect: '/flowable/list',
  meta: {
    hideChildrenInMenu: false,
    icon: 'simple-icons:about-dot-me',
    title: t('routes.dashboard.about'),
    orderNo: 100000,
  },
  children: [
    {
      path: 'list',
      name: 'list',
      component: () => import('/@/views/flowable/definition/index.vue'),
      meta: {
        title: '流程列表',
        icon: 'simple-icons:about-dot-me',
        hideMenu: false,
      },
    },
    {
      path: 'model',
      name: 'model',
      meta: {
        hideMenu: false,
        title:  '工作流建模',
      },
      component: () => import('/@/views/flowable/definition/model.vue'),
    },
  ],
};
